import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

const getLegendLabel = (type, name, val) => {
  if (type === "pie") {
    let gap = "・ ・ ・ ・ ・ ・ ・";
    if (window.screen.width < 401 || name.length > 10) {
      gap = " ・ ・ ";
    }
    return [name, gap, val];
  } else {
    let gap = " ・ ・ ";
    if (window.screen.width < 401 || name.length > 10) {
      gap = " ・・・ ";
    }
    return [name, gap, val];
  }
};

export const RadioResultForm = (props) => {
  const [params, setParams] = useState({
    type: "pie",
    series: [],
    options: {},
  });

  useEffect(() => {
    if (props) {
      const { series, labels, height } = props;
      setParams({
        type: "pie",
        series,
        height,
        options: {
          labels,
          dataLabels: {
            enabled: false,
          },
          legend: {
            position: "left",
            fontSize: "14px",
            formatter: (seriesName, opts) =>
              getLegendLabel(
                "pie",
                seriesName,
                opts.w.globals.series[opts.seriesIndex]
              ),
            markers: {
              width: 16,
              height: 16,
              offsetY: 1,
              offsetX: -3,
            },
          },
          plotOptions: {
            pie: {
              size: 200,
            },
          },
          responsive: [
            {
              breakpoint: 400,
              options: {
                // labels: abbrLabels || labels,
                labels,
                chart: {
                  width: "100%",
                  offsetX: -10,
                },
                legend: {
                  fontSize: "14px",
                  width: 160,
                  markers: {
                    width: 16,
                    height: 16,
                    offsetY: 1,
                    offsetX: -4,
                  },
                },
              },
            },
          ],
        },
      });
    }
  }, [props]);
  return <Chart {...params} />;
};

export const CheckboxResultForm = (props) => {
  const [params, setParams] = useState({
    type: "bar",
    series: [],
    options: {},
  });

  useEffect(() => {
    if (props) {
      const { series, labels, height } = props;
      setParams({
        type: "bar",
        series: [{ data: series }],
        options: {
          theme: {
            monochrome: {
              enabled: labels.length > 5,
              shadeTo: "dark",
            },
          },
          chart: {
            type: "bar",
            width: "100%",
            toolbar: {
              show: false,
            },
            sparkline: {
              enabled: false,
            },
          },
          plotOptions: {
            bar: {
              columnWidth: "70%",
              distributed: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          grid: {
            xaxis: {
              lines: {
                show: false,
              },
            },
            yaxis: {
              lines: {
                show: true,
              },
            },
          },
          legend: {
            show: true,
            position: "left",
            fontSize: "14px",
            horizontalAlign: "left",
            formatter: (seriesName, opts) =>
              getLegendLabel(
                "bar",
                seriesName,
                opts.w.globals.series[0][opts.seriesIndex]
              ),
            markers: {
              radius: 12,
              width: 16,
              height: 16,
              offsetY: 1,
              offsetX: -3,
            },
          },
          xaxis: {
            categories: labels,
            labels: {
              show: false,
            },
          },
        },
        height: height + 100,
      });
    }
  }, [props]);
  return <Chart {...params} />;
};

export const RatingResultForm = (props) => {
  const [params, setParams] = useState({
    type: "bar",
    series: [],
    options: {},
  });
  const [average, setAvg] = useState("0.0");

  useEffect(() => {
    if (props) {
      const { series, labels, height, average: avg } = props;
      setAvg(avg);
      setParams({
        type: "bar",
        series: [
          {
            name: "🗳",
            data: series,
          },
        ],
        options: {
          chart: {
            type: "bar",
            width: "100%",
            toolbar: {
              show: false,
            },
            sparkline: {
              enabled: false,
            },
          },
          plotOptions: {
            bar: {
              columnWidth: "70%",
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: true,
            position: "left",
            fontSize: "14px",
            horizontalAlign: "left",
            formatter: () => {
              return [];
            },
            markers: {
              width: 12,
              height: 12,
            },
          },
          grid: {
            xaxis: {
              lines: {
                show: false,
              },
            },
            yaxis: {
              lines: {
                show: true,
              },
            },
          },
          xaxis: {
            categories: labels,
          },
        },
        height: height + 100,
      });
    }
  }, [props]);
  return (
    <div className="flex flex-row items-center">
      <div className="stat text-center flex-[25%] grow-0">
        <div className="stat-value text-2xl">{average || 0}</div>
        <div className="stat-desc">평균 점수</div>
      </div>
      <Chart {...params} width="100%" />
    </div>
  );
};

export const TextResultForm = (props) => {
  const { total, series } = props;
  return (
    <div className={`flex flex-row items-center max-h-[12rem] mt-2`}>
      <div className="stat text-center flex-[25%]">
        <div className="stat-value text-2xl">{total}</div>
        <div className="stat-desc">응답</div>
      </div>
      <div
        className={`overflow-scroll scrollbar-hide h-[12rem] px-2 py-2 md:px-6 md:py-4 w-full border-solid border-zinc-200 border rounded-lg`}
      >
        {series.map((v, i) => (
          <p className="italic font-normal" key={`trm_${i}`}>
            {v}
          </p>
        ))}
      </div>
    </div>
  );
};
